import React from "react";
import { FaShare } from "react-icons/fa";
import globalStyles from "../../../styles/globalStyles.module.css";
import { useAlert } from "../../../context/AlertProvider";

export const ShareButton: React.FC = () => {
  const { showAlert } = useAlert();

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        showAlert("URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        showAlert("Failed to copy URL.");
      });
  };

  return (
    <>
      <button className={globalStyles.button} onClick={copyToClipboard}>
        <FaShare />
      </button>
    </>
  );
};
